// extracted by mini-css-extract-plugin
export default {"wrapper":"RightDetailsPage_wrapper__cpA4Z","content":"RightDetailsPage_content__Tkcrp","actions":"RightDetailsPage_actions__bTbJG","list":"RightDetailsPage_list__DUfbK"};